import { useEffect } from "react";
import { useAppSelector } from "@app/hooks";
import { blurMarks } from "@features/setting/helper";
import { useHasChange, useOnCancel } from "@features/setting/hooks";
import FloatingPanelComponent from "@share/components/FloatingPanel";
import {
  BLOCK_SETTING_DEFAULT_VALUE,
  MAX_WIDTH_CONTENT_LAYOUT,
} from "@share/configs/const";
import { saveThemeBlockSetting } from "@share/thunk";
import {
  Button,
  Collapse,
  Selector,
  Slider,
  Switch,
  Divider,
} from "antd-mobile";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import { ColorPickerV2 } from "../ColorPicker";
import SettingHeader from "../SettingHeader";
import BlockStyle from "./components/BlockStyle";
import { DashIcon, DotIcon, ShadowIcon, SolidIcon } from "./components/Icons";
import Preview from "./components/Preview";
import DisplayColor from "@share/components/DisplayColor";
import {
  DashRoundedIcon,
  DotRoundedIcon,
  NoShadowRoundedIcon,
} from "../../Icons";
import gaEvents, { CATEGORY_CONFIG, LABEL_CONFIG } from "@share/lib/ga-events";
import { handleCapitalizeFirstLetter } from "@share/lib";
import PopupComponent from "@share/components/PopupComponent";
import { DropDownIcon1, DropDownIcon2 } from "@share/icons";
import { useToast } from "@share/hooks/toast";
import {selectProfile} from "@features/user/userSlice";

const BlockIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M19.2526 1.83447H8.2526C8.00949 1.83447 7.77633 1.93105 7.60442 2.10296C7.43251 2.27487 7.33594 2.50802 7.33594 2.75114V6.41781H5.5026C5.25949 6.41781 5.02633 6.51438 4.85442 6.68629C4.68251 6.8582 4.58594 7.09136 4.58594 7.33447V11.0011H2.7526C2.50949 11.0011 2.27633 11.0977 2.10442 11.2696C1.93251 11.4415 1.83594 11.6747 1.83594 11.9178V19.2511C1.83594 19.4943 1.93251 19.7274 2.10442 19.8993C2.27633 20.0712 2.50949 20.1678 2.7526 20.1678H10.0859C10.3291 20.1678 10.5622 20.0712 10.7341 19.8993C10.906 19.7274 11.0026 19.4943 11.0026 19.2511V17.4178H14.6693C14.9124 17.4178 15.1455 17.3212 15.3175 17.1493C15.4894 16.9774 15.5859 16.7443 15.5859 16.5011V14.6678H19.2526C19.4957 14.6678 19.7289 14.5712 19.9008 14.3993C20.0727 14.2274 20.1693 13.9943 20.1693 13.7511V2.75114C20.1693 2.50802 20.0727 2.27487 19.9008 2.10296C19.7289 1.93105 19.4957 1.83447 19.2526 1.83447ZM9.16927 18.3345H3.66927V12.8345H9.16927V18.3345ZM13.7526 15.5845H11.0026V11.9178C11.0026 11.6747 10.906 11.4415 10.7341 11.2696C10.5622 11.0977 10.3291 11.0011 10.0859 11.0011H6.41927V8.25114H13.7526V15.5845ZM18.3359 12.8345H15.5859V7.33447C15.5859 7.09136 15.4894 6.8582 15.3175 6.68629C15.1455 6.51438 14.9124 6.41781 14.6693 6.41781H9.16927V3.66781H18.3359V12.8345Z"
      fill="#333333"
    />
  </svg>
);

const StyleIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M18.3359 6.26203C18.336 6.25206 18.3361 6.24028 18.3361 6.22847C18.3361 5.52443 18.0486 4.88754 17.5845 4.42894L17.5842 4.42872C17.1091 3.9727 16.4628 3.69189 15.7509 3.69189C15.0391 3.69189 14.3927 3.9727 13.9167 4.42962L13.9176 4.42877L7.86759 10.4788H7.6659C5.51024 10.5385 3.77882 12.2731 3.72433 14.4245L3.72425 14.4296L3.66925 17.4179C3.66907 17.4249 3.66895 17.4331 3.66895 17.4412C3.66895 17.6932 3.77057 17.9214 3.93514 18.0871L3.93509 18.0871C4.10499 18.2406 4.33122 18.3346 4.57945 18.3346C4.58173 18.3346 4.58401 18.3346 4.58629 18.3346H4.58594L7.57429 18.2796C9.73081 18.225 11.4654 16.4936 11.525 14.3435L11.5251 14.3379V14.1271L17.5843 8.07711C18.0484 7.62109 18.3361 6.98669 18.3361 6.28514C18.3361 6.27707 18.336 6.26899 18.336 6.26091V6.26216L18.3359 6.26203ZM7.56509 16.4462L5.50259 16.5012V14.457C5.52322 13.2579 6.50016 12.2937 7.70229 12.2937C7.70238 12.2937 7.70251 12.2937 7.70259 12.2937C7.70268 12.2937 7.70281 12.2937 7.70294 12.2937C8.79142 12.2937 9.67379 13.176 9.67379 14.2645C9.67379 14.2774 9.67366 14.2903 9.67344 14.3031V14.3012C9.64452 15.4613 8.72186 16.3968 7.56961 16.446L7.56509 16.4461V16.4462ZM16.2918 6.77538L10.911 12.1562C10.7626 11.9369 10.6058 11.7452 10.4335 11.5687L10.4343 11.5695C10.26 11.3946 10.068 11.2376 9.86117 11.1012L9.84764 11.0928L15.2285 5.72118C15.3665 5.58931 15.5538 5.50814 15.7601 5.50814C15.9664 5.50814 16.1539 5.58931 16.2921 5.72144L16.2918 5.72118C16.4224 5.8549 16.5029 6.03795 16.5029 6.23981C16.5029 6.24759 16.5028 6.25541 16.5026 6.26314V6.26203C16.5026 6.2628 16.5026 6.26366 16.5026 6.26456C16.5026 6.46389 16.422 6.64441 16.2917 6.77538H16.2918Z"
      fill="#333333"
    />
  </svg>
);

const BackgroundIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7831_219988)">
      <rect
        width="22"
        height="22"
        transform="translate(0 0.00244141)"
        fill="white"
        fillOpacity="0.01"
      />
      <path
        d="M6.41927 14.6702C6.23797 14.6702 6.06074 14.724 5.91 14.8247C5.75925 14.9255 5.64176 15.0686 5.57238 15.2361C5.503 15.4036 5.48485 15.5879 5.52022 15.7657C5.55559 15.9436 5.64289 16.1069 5.77109 16.2351C5.89929 16.3633 6.06262 16.4506 6.24044 16.486C6.41825 16.5213 6.60256 16.5032 6.77006 16.4338C6.93756 16.3644 7.08073 16.2469 7.18145 16.0962C7.28218 15.9454 7.33594 15.7682 7.33594 15.5869C7.33594 15.3438 7.23936 15.1106 7.06745 14.9387C6.89554 14.7668 6.66239 14.6702 6.41927 14.6702ZM17.4743 11.0036L18.6018 9.87608C19.1168 9.36045 19.406 8.6615 19.406 7.93275C19.406 7.20399 19.1168 6.50504 18.6018 5.98941L16.0076 3.40441C15.492 2.88943 14.793 2.60017 14.0643 2.60017C13.3355 2.60017 12.6366 2.88943 12.1209 3.40441L11.0026 4.53191C10.9882 3.81214 10.6921 3.12672 10.178 2.62283C9.66378 2.11894 8.97252 1.83677 8.2526 1.83691H4.58594C3.85659 1.83691 3.15712 2.12665 2.64139 2.64237C2.12567 3.1581 1.83594 3.85757 1.83594 4.58691V17.4202C1.83594 18.1496 2.12567 18.8491 2.64139 19.3648C3.15712 19.8805 3.85659 20.1702 4.58594 20.1702H17.4193C18.1486 20.1702 18.8481 19.8805 19.3638 19.3648C19.8795 18.8491 20.1693 18.1496 20.1693 17.4202V13.7536C20.1694 13.0337 19.8872 12.3424 19.3834 11.8282C18.8795 11.3141 18.194 11.018 17.4743 11.0036ZM9.16927 17.4202C9.16927 17.6634 9.07269 17.8965 8.90078 18.0684C8.72888 18.2403 8.49572 18.3369 8.2526 18.3369H4.58594C4.34282 18.3369 4.10966 18.2403 3.93776 18.0684C3.76585 17.8965 3.66927 17.6634 3.66927 17.4202V4.58691C3.66927 4.3438 3.76585 4.11064 3.93776 3.93873C4.10966 3.76682 4.34282 3.67025 4.58594 3.67025H8.2526C8.49572 3.67025 8.72888 3.76682 8.90078 3.93873C9.07269 4.11064 9.16927 4.3438 9.16927 4.58691V17.4202ZM11.0026 7.11691L13.4226 4.69691C13.5944 4.52618 13.8267 4.43035 14.0689 4.43035C14.311 4.43035 14.5434 4.52618 14.7151 4.69691L17.3093 7.33691C17.48 7.50866 17.5758 7.74099 17.5758 7.98316C17.5758 8.22533 17.48 8.45766 17.3093 8.62941L14.6693 11.2694L11.0026 14.8902V7.11691ZM18.3359 17.4202C18.3359 17.6634 18.2394 17.8965 18.0675 18.0684C17.8955 18.2403 17.6624 18.3369 17.4193 18.3369H10.8376C10.9316 18.0652 10.9842 17.7809 10.9934 17.4936L15.6501 12.8369H17.4193C17.6624 12.8369 17.8955 12.9335 18.0675 13.1054C18.2394 13.2773 18.3359 13.5105 18.3359 13.7536V17.4202Z"
        fill="#333333"
      />
    </g>
    <defs>
      <clipPath id="clip0_7831_219988">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(0 0.00244141)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BorderIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7831_220095)">
      <rect
        width="22"
        height="22"
        transform="translate(0 0.00341797)"
        fill="white"
        fillOpacity="0.01"
      />
      <path
        d="M10.5444 16.9631C10.3631 16.9631 10.1859 17.0168 10.0352 17.1175C9.88442 17.2183 9.76692 17.3614 9.69754 17.5289C9.62816 17.6964 9.61001 17.8807 9.64538 18.0586C9.68075 18.2364 9.76805 18.3997 9.89625 18.5279C10.0245 18.6561 10.1878 18.7434 10.3656 18.7788C10.5434 18.8141 10.7277 18.796 10.8952 18.7266C11.0627 18.6572 11.2059 18.5397 11.3066 18.389C11.4073 18.2382 11.4611 18.061 11.4611 17.8797C11.4611 17.6366 11.3645 17.4034 11.1926 17.2315C11.0207 17.0596 10.7875 16.9631 10.5444 16.9631ZM18.7944 3.21305C18.7944 2.96994 18.6979 2.73678 18.5259 2.56487C18.354 2.39296 18.1209 2.29639 17.8778 2.29639H3.2111C2.96799 2.29639 2.73483 2.39296 2.56292 2.56487C2.39101 2.73678 2.29443 2.96994 2.29443 3.21305V17.8797C2.29443 18.1228 2.39101 18.356 2.56292 18.5279C2.73483 18.6998 2.96799 18.7964 3.2111 18.7964C3.45422 18.7964 3.68737 18.6998 3.85928 18.5279C4.03119 18.356 4.12777 18.1228 4.12777 17.8797V4.12972H17.8778C18.1209 4.12972 18.354 4.03314 18.5259 3.86123C18.6979 3.68933 18.7944 3.45617 18.7944 3.21305ZM14.2111 16.9631C14.0298 16.9631 13.8526 17.0168 13.7018 17.1175C13.5511 17.2183 13.4336 17.3614 13.3642 17.5289C13.2948 17.6964 13.2767 17.8807 13.312 18.0586C13.3474 18.2364 13.4347 18.3997 13.5629 18.5279C13.6911 18.6561 13.8545 18.7434 14.0323 18.7788C14.2101 18.8141 14.3944 18.796 14.5619 18.7266C14.7294 18.6572 14.8726 18.5397 14.9733 18.389C15.074 18.2382 15.1278 18.061 15.1278 17.8797C15.1278 17.6366 15.0312 17.4034 14.8593 17.2315C14.6874 17.0596 14.4542 16.9631 14.2111 16.9631ZM6.87777 16.9631C6.69647 16.9631 6.51924 17.0168 6.36849 17.1175C6.21775 17.2183 6.10026 17.3614 6.03088 17.5289C5.9615 17.6964 5.94334 17.8807 5.97871 18.0586C6.01408 18.2364 6.10139 18.3997 6.22959 18.5279C6.35778 18.6561 6.52112 18.7434 6.69893 18.7788C6.87675 18.8141 7.06106 18.796 7.22856 18.7266C7.39606 18.6572 7.53922 18.5397 7.63995 18.389C7.74067 18.2382 7.79443 18.061 7.79443 17.8797C7.79443 17.6366 7.69786 17.4034 7.52595 17.2315C7.35404 17.0596 7.12088 16.9631 6.87777 16.9631ZM17.8778 5.96305C17.6965 5.96305 17.5192 6.01682 17.3685 6.11754C17.2177 6.21826 17.1003 6.36143 17.0309 6.52893C16.9615 6.69643 16.9433 6.88074 16.9787 7.05855C17.0141 7.23637 17.1014 7.3997 17.2296 7.5279C17.3578 7.6561 17.5211 7.7434 17.6989 7.77877C17.8767 7.81414 18.0611 7.79599 18.2286 7.72661C18.3961 7.65723 18.5392 7.53974 18.6399 7.38899C18.7407 7.23825 18.7944 7.06102 18.7944 6.87972C18.7944 6.6366 18.6979 6.40345 18.5259 6.23154C18.354 6.05963 18.1209 5.96305 17.8778 5.96305ZM17.8778 9.62972C17.6965 9.62972 17.5192 9.68348 17.3685 9.78421C17.2177 9.88493 17.1003 10.0281 17.0309 10.1956C16.9615 10.3631 16.9433 10.5474 16.9787 10.7252C17.0141 10.903 17.1014 11.0664 17.2296 11.1946C17.3578 11.3228 17.5211 11.4101 17.6989 11.4454C17.8767 11.4808 18.0611 11.4627 18.2286 11.3933C18.3961 11.3239 18.5392 11.2064 18.6399 11.0557C18.7407 10.9049 18.7944 10.7277 18.7944 10.5464C18.7944 10.3033 18.6979 10.0701 18.5259 9.89821C18.354 9.7263 18.1209 9.62972 17.8778 9.62972ZM17.8778 13.2964C17.6965 13.2964 17.5192 13.3501 17.3685 13.4509C17.2177 13.5516 17.1003 13.6948 17.0309 13.8623C16.9615 14.0298 16.9433 14.2141 16.9787 14.3919C17.0141 14.5697 17.1014 14.733 17.2296 14.8612C17.3578 14.9894 17.5211 15.0767 17.6989 15.1121C17.8767 15.1475 18.0611 15.1293 18.2286 15.0599C18.3961 14.9906 18.5392 14.8731 18.6399 14.7223C18.7407 14.5716 18.7944 14.3944 18.7944 14.2131C18.7944 13.9699 18.6979 13.7368 18.5259 13.5649C18.354 13.393 18.1209 13.2964 17.8778 13.2964ZM17.8778 16.9631C17.6965 16.9631 17.5192 17.0168 17.3685 17.1175C17.2177 17.2183 17.1003 17.3614 17.0309 17.5289C16.9615 17.6964 16.9433 17.8807 16.9787 18.0586C17.0141 18.2364 17.1014 18.3997 17.2296 18.5279C17.3578 18.6561 17.5211 18.7434 17.6989 18.7788C17.8767 18.8141 18.0611 18.796 18.2286 18.7266C18.3961 18.6572 18.5392 18.5397 18.6399 18.389C18.7407 18.2382 18.7944 18.061 18.7944 17.8797C18.7944 17.6366 18.6979 17.4034 18.5259 17.2315C18.354 17.0596 18.1209 16.9631 17.8778 16.9631Z"
        fill="#333333"
      />
    </g>
    <defs>
      <clipPath id="clip0_7831_220095">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(0 0.00341797)"
        />
      </clipPath>
    </defs>
  </svg>
);
interface BlockSettingDataInterface {
  block_style: {
    radius_type: string;
    radius_value: number | undefined;
    inner_space: boolean;
    block_space: number;
    inner_space_number?: number;
    outside_space?: boolean;
  };
  block_background: {
    color: string;
    blur: number;
    meta: any;
  };
  block_border: {
    enable: boolean;
    color: string;
    color_meta: any;
    type: string;
    border_width: number | undefined;
  };
  block_shadow: {
    enable: boolean;
    color: string;
    color_meta: any;
  };
}

const defaultSettingState: BlockSettingDataInterface = {
  block_style: {
    radius_type: BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE,
    radius_value: BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS,
    inner_space: BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE,
    block_space: BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE,
    inner_space_number: BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER,
    outside_space: BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE,
  },
  block_background: {
    color: BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR,
    blur: BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR,
    meta: {},
  },
  block_border: {
    enable: BLOCK_SETTING_DEFAULT_VALUE.BORDER_ENABLE,
    color: BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR,
    color_meta: {},
    type: BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE,
    border_width: BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH,
  },
  block_shadow: {
    enable: BLOCK_SETTING_DEFAULT_VALUE.SHADOW_ENABLE,
    color: BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR,
    color_meta: {},
  },
};

export default function BlockSetting(props) {
  const BLUR_BACKGROUND_MAXIMUM = 100;
  const { backToAllSetting, type } = props;
  const { t } = useTranslation();
  const { SuccessToast } = useToast();
  const blockSetting = useAppSelector(
    (state) => state?.siteSettings?.display_setting?.block_setting
  );

  const [blockSettingData, setBlockSettingData] =
    useState<BlockSettingDataInterface>(blockSetting ?? defaultSettingState);
  const { block_background, block_border, block_shadow } = blockSettingData;
  const passioPageProfile = useAppSelector((state) => state.passioPageProfile);

  const [isOpenBackgroudPicker, setIsOpenBackgroundPicker] =
    useState<boolean>(false);
  const [isOpenBorderColorPicker, setIsOpenBorderColorPicker] =
    useState<boolean>(false);
  const [isOpenShadowColorPicker, setIsOpenShadowColorPicker] =
    useState<boolean>(false);

  const dispatch = useDispatch();

  const saveBlockSetting = () => {
    dispatch(saveThemeBlockSetting(blockSettingData));
    backToAllSetting();
    gaEvents.submitEventV2(
      passioPageProfile,
      CATEGORY_CONFIG.THEME_SETTINGS,
      `ThemeSettings_${handleCapitalizeFirstLetter(type)}_${LABEL_CONFIG.EDIT}`,
      LABEL_CONFIG.EDIT,
      handleCapitalizeFirstLetter(type)
    );
    SuccessToast(t("ss_builder_save_succesfully_label"));
  };

  const hasChange = useHasChange([blockSettingData]);
  const onCancel = useOnCancel(hasChange, backToAllSetting, type);

  const onChangeRadius = (data) => {
    setBlockSettingData((state) => {
      return { ...state, block_style: data };
    });
  };

  const onChangeBlockBackground = (color) => {
    const data = {
      color: color,
    };
    setBlockSettingData((state) => {
      return {
        ...state,
        block_background: { ...state.block_background, ...data },
      };
    });
  };

  const onChangeBorderColor = (color) => {
    const data = {
      color: color,
    };
    setBlockSettingData((state) => {
      return { ...state, block_border: { ...state.block_border, ...data } };
    });
  };

  const onChangeShadowColor = (color) => {
    const data = {
      color: color,
    };
    setBlockSettingData((state) => {
      return { ...state, block_shadow: { ...state.block_shadow, ...data } };
    });
  };

  const onChangeBlockBackgroundBlur = (blur) => {
    setBlockSettingData((state) => {
      return {
        ...state,
        block_background: { ...state.block_background, blur: blur },
      };
    });
  };

  const onUpdateBorderData = (key, value) => {
    setBlockSettingData((state) => {
      return {
        ...state,
        block_border: { ...state.block_border, [key]: value },
      };
    });
  };

  const onUpdateShadowData = (key, value) => {
    setBlockSettingData((state) => {
      return {
        ...state,
        block_shadow: { ...state.block_shadow, [key]: value },
      };
    });
  };

  return (
    <>
      <div className="w-full pb-14">
        <SettingHeader
          title={t("ss_builder_block_setting_title")}
          Icon={BlockIcon}
        />
        <div className="sticky z-[999] top-0">
          <Preview defaultValue={blockSettingData ?? {}} />
        </div>

        <Collapse
          defaultActiveKey={["style", "background", "border", "shadow"]}
          accordion={false}
          arrow={(active) => (active ? <DropDownIcon1 /> : <DropDownIcon2 />)}
        >
          <Collapse.Panel
            key="style"
            title={
              <>
                <div className="flex">
                  <span className="mr-1">
                    <StyleIcon />
                  </span>
                  <span>{t("ss_builder_theme_setting_block_style")}</span>
                </div>
              </>
            }
          >
            <BlockStyle
              defaultValue={blockSettingData?.block_style ?? {}}
              onUpdateRadius={onChangeRadius}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key="background"
            title={
              <>
                <div className="flex">
                  <span className="mr-1">
                    <BackgroundIcon />
                  </span>
                  <span>{t("ss_builder_theme_setting_block_background")}</span>
                </div>
              </>
            }
          >
            <div className="text-base mb-1">
              {t("ss_builder_block_background_color")}
            </div>
            <DisplayColor
              backgroundColor={block_background.color}
              onClickOpenColorPicker={setIsOpenBackgroundPicker}
            />
            <Divider />
            <div className="text-base mb-1 flex justify-between">
              <span>{t("ss_builder_block_background_blur")}</span>
              <span className="primary-color text-sm">
                {block_background?.blur ?? 0} px
              </span>
            </div>
            <Slider
              onChange={onChangeBlockBackgroundBlur}
              // ticks={true}
              marks={blurMarks}
              min={0}
              step={1}
              max={BLUR_BACKGROUND_MAXIMUM}
              popover={true}
              defaultValue={block_background?.blur ?? 0}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key="border"
            title={
              <>
                <div className="flex">
                  <span className="mr-1">
                    <BorderIcon />
                  </span>
                  <span>{t("ss_builder_theme_setting_block_border")}</span>
                </div>
              </>
            }
          >
            <div className="mb-3">
              <div className="text-base mb-4">
                {t("ss_builder_enable_border")}
              </div>
              <Switch
                defaultChecked={block_border?.enable ?? false}
                uncheckedText={t("ss_builder_off")}
                checkedText={t("ss_builder_on")}
                onChange={(value) => onUpdateBorderData("enable", value)}
              />
            </div>
            {block_border?.enable && (
              <>
                <div className="mb-3">
                  <div className="text-base mb-4">
                    {t("ss_builder_block_border_color")}
                  </div>
                  <DisplayColor
                    backgroundColor={block_border.color}
                    onClickOpenColorPicker={setIsOpenBorderColorPicker}
                  />
                </div>
                <Divider />
                <div className="mb-4">
                  <div className="text-base mb-2">
                    {t("ss_builder_block_border_style")}
                  </div>
                  <Selector
                    className=""
                    columns={3}
                    onChange={(val) => {
                      onUpdateBorderData("type", val.length ? val[0] : "solid");
                    }}
                    options={[
                      {
                        label: <NoShadowRoundedIcon className={"m-auto"} />,
                        description: t("ss_builder_border_solid"),
                        value: "solid",
                      },
                      {
                        label: <DotRoundedIcon className={"m-auto"} />,
                        description: t("ss_builder_border_dot"),
                        value: "dotted",
                      },
                      {
                        label: <DashRoundedIcon className={"m-auto"} />,
                        description: t("ss_builder_border_dash"),
                        value: "dashed",
                      },
                    ]}
                    defaultValue={[
                      blockSettingData?.block_border?.type ?? "solid",
                    ]}
                    style={{
                      "--checked-color": "#fff",
                    }}
                  />
                </div>
                <Divider />
                <div className="mb-3">
                  <div className="text-base mb-4">
                    {t("ss_builder_button_border_width")}
                  </div>
                  <Slider
                    onChange={(val) =>
                      onUpdateBorderData(
                        "border_width",
                        parseInt(val.toString()) || 1
                      )
                    }
                    marks={{
                      1: 1,
                      2: 2,
                      3: 3,
                      4: 4,
                      5: 5,
                      6: 6,
                      7: 7,
                      8: 8,
                      9: 9,
                      10: 10,
                      11: 11,
                      12: 12,
                    }}
                    min={1}
                    max={12}
                    step={1}
                    value={blockSettingData?.block_border?.border_width ?? 1}
                    ticks={true}
                  />
                </div>
              </>
            )}
          </Collapse.Panel>
          <Collapse.Panel
            key="shadow"
            title={
              <>
                <div className="flex">
                  <span className="mr-1">
                    <ShadowIcon className={""} />
                  </span>
                  <span>{t("ss_builder_theme_setting_block_shadow")}</span>
                </div>
              </>
            }
          >
            <div className="mb-3">
              <div className="text-base mb-4">
                {t("ss_builder_enable_shadow")}
              </div>
              <Switch
                defaultChecked={block_shadow?.enable ?? false}
                uncheckedText={t("ss_builder_off")}
                checkedText={t("ss_builder_on")}
                onChange={(value) => onUpdateShadowData("enable", value)}
              />
            </div>
            {block_shadow?.enable && (
              <div className="mb-3">
                <div className="text-base mb-4">
                  {t("ss_builder_block_shadow_color")}
                </div>
                <DisplayColor
                  backgroundColor={block_shadow.color}
                  onClickOpenColorPicker={setIsOpenShadowColorPicker}
                />
              </div>
            )}
          </Collapse.Panel>
        </Collapse>
      </div>
      <div className="max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]">
        <div className="w-1/2 text-center">
          <Button
            onClick={onCancel}
            className="adm-button adm-button-default adm-button-shape-default w-full"
          >
            {t("ss_builder_close_panel")}
          </Button>
        </div>
        <div className="w-1/2 text-center">
          <Button
            color="primary"
            disabled={!hasChange}
            className="adm-button adm-button-primary adm-button-shape-default w-full"
            onClick={() => {
              saveBlockSetting();
            }}
          >
            {t("ss_builder_save")}
          </Button>
        </div>
      </div>

      <PopupComponent
        visible={isOpenBackgroudPicker}
        onMaskClick={() => setIsOpenBackgroundPicker(false)}
        title={t("ss_builder_color_picker_panel_title")}
        onClose={() => setIsOpenBackgroundPicker(false)}
        classNameBody="h-[60vh] popup-hard"
      >
        <ColorPickerV2
          defaultColor={block_background?.color ?? "white"}
          onCancel={() => {
            setIsOpenBackgroundPicker(false);
          }}
          onColorSelected={onChangeBlockBackground}
        />
      </PopupComponent>

      <PopupComponent
        visible={isOpenBorderColorPicker}
        onMaskClick={() => setIsOpenBorderColorPicker(false)}
        title={t("ss_builder_color_picker_panel_title")}
        onClose={() => setIsOpenBorderColorPicker(false)}
        classNameBody="h-[60vh] popup-hard"
      >
        <ColorPickerV2
          defaultColor={block_border?.color ?? "black"}
          onCancel={() => {
            setIsOpenBorderColorPicker(false);
          }}
          onColorSelected={onChangeBorderColor}
        />
      </PopupComponent>

      <PopupComponent
        visible={isOpenShadowColorPicker}
        onMaskClick={() => setIsOpenShadowColorPicker(false)}
        title={t("ss_builder_color_picker_panel_title")}
        onClose={() => setIsOpenShadowColorPicker(false)}
        classNameBody="h-[60vh] popup-hard"
      >
        <ColorPickerV2
          defaultColor={block_shadow?.color ?? "black"}
          onCancel={() => {
            setIsOpenShadowColorPicker(false);
          }}
          onColorSelected={onChangeShadowColor}
        />
      </PopupComponent>
    </>
  );
}
